import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import TextInput from '../../components/formComponents/inputs/TextInput';

export default class ReviewWorkspaceTopLevelComment extends PureComponent {
    static propTypes = {
        onResolve: PropTypes.func,
        onDelete: PropTypes.func,
        handleAssetReviewItemEdit: PropTypes.func,
        renderCommentAuthor: PropTypes.func,
        handleReplyIconClick: PropTypes.func,
        renderCommentBody: PropTypes.func,
        onSaveEdit: PropTypes.func,
        handleEditIconClick: PropTypes.func,
        assetReviewItem: PropTypes.object,
        loggedInUserId: PropTypes.string,
        isBuilder: PropTypes.bool,
        isEditing: PropTypes.bool,
        isContentAdmin: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            commentBody: ''
        };
    }

    componentDidMount() {
        const { assetReviewItem } = this.props;
        return this.setState({ commentBody: assetReviewItem.body });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.assetReviewItem.body !== this.props.assetReviewItem.body) {
            this.setState({ commentBody: this.props.assetReviewItem.body });
        }
    }

    _handleSaveIconClick = () => {
        const { assetReviewItem, onSaveEdit } = this.props;
        const { commentBody } = this.state;

        if (assetReviewItem.body !== commentBody) {
            return this._submitCommentEdit();
        }
        return onSaveEdit();
    };

    _submitCommentEdit = () => {
        const { handleAssetReviewItemEdit, assetReviewItem, onSaveEdit } = this.props;
        const { commentBody } = this.state;
        return handleAssetReviewItemEdit(assetReviewItem._id, commentBody).then(() => onSaveEdit());
    };

    handleResolve = () => {
        const { onResolve, assetReviewItem } = this.props;
        if (onResolve) {
            return onResolve(assetReviewItem)();
        }
        return null;
    };

    handleDelete = () => {
        const { onDelete, assetReviewItem } = this.props;
        if (onDelete) {
            return onDelete(assetReviewItem)();
        }
        return null;
    };

    _renderHeading = (assetReviewItem) => {
        const { isBuilder, renderCommentAuthor } = this.props;
        const author = renderCommentAuthor(assetReviewItem);
        const issueType = <p className={'comment-item-review-type'}>{assetReviewItem.type}</p>;
        if (isBuilder) {
            return (
                <div className={'top-level-comment-heading'}>
                    <span className={'comment-item-title'}>{`${assetReviewItem.status} ISSUE`}</span>
                    {issueType}
                    {author}
                </div>
            );
        }
        return (
            <div className={'top-level-comment-heading'}>
                {author}
                {issueType}
            </div>
        );
    };

    render() {
        const {
            assetReviewItem,
            loggedInUserId,
            isBuilder,
            handleReplyIconClick,
            renderCommentBody,
            handleEditIconClick,
            isEditing,
            isContentAdmin
        } = this.props;
        const { commentBody } = this.state;
        const isResolved = assetReviewItem.status === 'RESOLVED';
        const isOwnComment = assetReviewItem.userProfileId === loggedInUserId;
        const isEditable = !isResolved && isOwnComment && !isBuilder;

        return (
            <div className={'top-level-comment row'}>
                <div className={'col-1'}>
                    <i
                        className={cns('fas fa-check-circle comment-status', { resolved: isResolved })}
                        onClick={this.handleResolve}
                    />
                </div>
                <div className={'col-11'}>
                    {this._renderHeading(assetReviewItem)}
                    {isEditing ? (
                        <i className={cns('comment-save-icon', 'fas fa-save')} onClick={this._handleSaveIconClick} />
                    ) : (
                        <div className={cns('action-icons', { hidden: isEditing })}>
                            {isEditable ? (
                                <i className={cns('comment-edit-icon', 'fa fa-pencil')} onClick={handleEditIconClick} />
                            ) : null}
                            <div className={'comment-reply-icon'} onClick={handleReplyIconClick}>
                                <i className={'fal fa-comment-lines'} />
                            </div>
                            {isContentAdmin && isResolved ? (
                                <i className={cns('comment-delete-iccon', 'fa fa-trash')} onClick={this.handleDelete} />
                            ) : null}
                        </div>
                    )}

                    {isEditing ? (
                        <TextInput
                            componentClass={'textarea'}
                            rows={4}
                            value={commentBody}
                            onChange={(e) => this.setState({ commentBody: e.target.value })}
                        />
                    ) : (
                        renderCommentBody(commentBody, assetReviewItem.createdOn)
                    )}
                </div>
            </div>
        );
    }
}
